import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentDialogSuggestionBannerAvatarUserImageWireframe from './VeltCommentDialogSuggestionBannerAvatarUserImageWireframe/VeltCommentDialogSuggestionBannerAvatarUserImageWireframe';
import VeltCommentDialogSuggestionBannerAvatarStatusIconWireframe from './VeltCommentDialogSuggestionBannerAvatarStatusIconWireframe/VeltCommentDialogSuggestionBannerAvatarStatusIconWireframe';
var VeltCommentDialogSuggestionBannerAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-banner-avatar-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionBannerAvatarWireframe.UserImage = VeltCommentDialogSuggestionBannerAvatarUserImageWireframe;
VeltCommentDialogSuggestionBannerAvatarWireframe.StatusIcon = VeltCommentDialogSuggestionBannerAvatarStatusIconWireframe;
export default VeltCommentDialogSuggestionBannerAvatarWireframe;
